import {alias, createModelSchema, reference, serialize} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {JobModel} from "../worker/jobs/JobModel";
import {GuardConfig} from "../guard/GuardConfig";
import {Currency} from "@/modules/redactor/models/currency/Currency";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";


export class RecipeModel extends BaseObject {

    static schema() {
        return reference("uid", (uid, cb) => {
            return cb(null, RedactorUtils.getRecipe(uid));
        });
    }

    constructor() {
        super();

        this._key = null;
        this._name = null;

        this._order = 0;
        this._guard = new GuardConfig();
        this._job = new JobModel();
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get order() {
        return this._order;
    }

    set order(value) {
        this._order = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get job() {
        return this._job;
    }

    set job(value) {
        this._job = value;
    }

    valid() {

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.job && !this.job.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RecipeModel());
        } else if (target instanceof RecipeModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    exportToJSON() {
        let job_config = this.job.data[0];
        let task = job_config.tasks[0];

        return {
            "uid": this.uid,
            "name": this.name,
            "enabled": this.enabled ? 1 : 0,
            "price": serialize(Currency, task.price)
        };
    }

    exportToCSV() {
        let job_config = this.job.data[0];
        let task = job_config.tasks[0];
        let result = this.name;

        for(let i =0;i<task.price.length;i+=1){
            let currency = task.price[i];
            result += "," + currency.kind.id + ":" + currency.amount;
        }

        return result;
    }
}

createModelSchema(RecipeModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _order: alias("order", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),
    _job: alias("job", JobModel.schema())
});